module.exports = __webpack_public_path__ + "img/poster.67f61cd3.png";